import { render, staticRenderFns } from "./CreatorVideoAvatar.vue?vue&type=template&id=ea2460ea&scoped=true&"
import script from "./CreatorVideoAvatar.vue?vue&type=script&lang=js&"
export * from "./CreatorVideoAvatar.vue?vue&type=script&lang=js&"
import style0 from "./CreatorVideoAvatar.vue?vue&type=style&index=0&id=ea2460ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2460ea",
  null
  
)

export default component.exports